<template>
  <header data-elementor-type="header"
          data-elementor-id="14"
          class="elementor elementor-14 elementor-location-header"
          data-elementor-post-type="elementor_library">
    <div class="elementor-element elementor-element-3246c11 e-flex e-con-boxed e-con e-parent e-lazyloaded"
         data-id="3246c11"
         data-element_type="container"
         data-e-type="container">
      <div class="e-con-inner">
        <div v-if="homeInfo?.homeContent?.pcImage1"
             class="elementor-element elementor-element-9df4a3d elementor-widget__width-initial elementor-widget elementor-widget-image"
             data-id="9df4a3d"
             data-element_type="widget"
             data-e-type="widget"
             data-widget_type="image.default">
          <router-link to="/home">
            <img fetchpriority="high"
                 width="800"
                 height="598"
                 :src="homeInfo?.homeContent?.pcImage1"
                 class="elementor-animation-shrink attachment-large size-large wp-image-21172"
                 alt=""
                 sizes="(max-width: 800px) 100vw, 800px">
          </router-link>
        </div>

        <span v-else></span>

        <div class="elementor-element elementor-element-bbc08cc e-con-full elementor-hidden-mobile e-flex e-con e-child"
             data-id="bbc08cc"
             data-element_type="container"
             data-e-type="container">
          <div class="elementor-element elementor-element-f3f735e elementor-icon-list--layout-inline elementor-hidden-mobile elementor-hidden-tablet elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
               data-id="f3f735e"
               data-element_type="widget"
               data-e-type="widget"
               data-widget_type="icon-list.default">
            <ul class="elementor-icon-list-items elementor-inline-items">
              <li v-for="item in navList"
                  :key="item.label"
                  class="elementor-icon-list-item elementor-inline-item">
                <a v-if="item.href.startsWith('http')"
                   :href="item.href"
                   target="_blank">
                  <span class="elementor-icon-list-text">
                    {{ item.label }}
                  </span>
                </a>
                <router-link v-else
                             :to="item.href">
                  <span class="elementor-icon-list-text">
                    {{ item.label }}
                  </span>
                </router-link>
              </li>
            </ul>
          </div>
          <!-- 加入 discord 按钮 -->
          <!-- <div
              class="elementor-element elementor-element-71a48ef elementor-tablet-align-center elementor-widget-tablet__width-inherit elementor-widget elementor-widget-button"
              data-id="71a48ef"
              data-element_type="widget"
              data-e-type="widget"
              data-widget_type="button.default"
            >
              <a
                class="elementor-button elementor-button-link elementor-size-sm"
                href="https://discord.gg/clonesoles-1096540420734988419"
                target="_blank"
              >
                <span
                  class="elementor-button-content-wrapper"
                >
                  <span
                    class="elementor-button-text"
                  >
                    JOIN THE DISCORD
                  </span>
                </span>
              </a>
            </div> -->

          <!-- 代购平台选择 -->
          <SelectPurchasingPlatform v-show="(!state.isMobile && homeInfo.showPlatform == 'Y') || (state.isMobile && homeInfo.mobileShowPlatform == 'Y')"
                                    :expert="expert"
                                    @handleChangeExpert="handleChangeExpert" />

          <div class="header-search elementor-hidden-mobile">
            <el-button class="icon-btn"
                       type="button"
                       aria-label="Search"
                       @click="dialogVisible = true">
              <i class="el-icon-search"></i>
            </el-button>
          </div>
        </div>

        <!-- 社交按钮 -->
        <div class="elementor-element elementor-element-ca503a9 elementor-shape-circle elementor-widget-tablet__width-auto elementor-hidden-mobile elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
             data-id="ca503a9"
             data-element_type="widget"
             data-e-type="widget"
             data-widget_type="social-icons.default">
          <!-- 与 Elementor 导出一致：widget-social-icons 的 font-size/间距依赖此层 -->
          <div class="elementor-widget-container">
            <div class="elementor-social-icons-wrapper elementor-grid"
                 role="list">
              <span v-for="(item, idx) in socialList"
                    :key="item.linkAddress || idx"
                    class="elementor-grid-item"
                    role="listitem">
                <a class="elementor-icon elementor-social-icon"
                   :href="item.linkAddress"
                   target="_blank">
                  <span class="social-icon-html"
                        v-html="item.url" />
                </a>
              </span>
            </div>
          </div>
        </div>

        <!-- 小屏菜单按钮 -->
        <div class="elementor-element elementor-element-a0f86c0 elementor-widget-mobile__width-initial elementor-hidden-desktop elementor-widget-tablet__width-initial elementor-view-default elementor-widget elementor-widget-icon"
             data-id="a0f86c0"
             data-element_type="widget"
             data-e-type="widget"
             data-widget_type="icon.default">
          <div class="elementor-icon-wrapper">
            <a class="elementor-icon"
               @click="state.mobileMenu.show = true">
              <svg aria-hidden="true"
                   class="e-font-icon-svg e-fas-th"
                   viewBox="0 0 512 512"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z">
                </path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible"
               width="40%"
               :show-close="false"
               :lock-scroll="false"
               :z-index="3210"
               modal-class="search-mask"
               custom-class="search-dialog"
               append-to-body
               :modal-append-to-body="true"
               @open="handleSearchOpen">
      <el-input v-model="state.searchValue"
                class="search-input--image"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search"
                autocomplete="off"
                @keyup.enter.native="goGoodsSearch">
        <template #append>
          <!-- 图片搜索按钮 -->
          <ImageSearchBtn />
        </template>
      </el-input>
    </el-dialog>

    <!-- 小屏弹窗 -->
    <div class="dialog-widget dialog-lightbox-widget dialog-type-buttons dialog-type-lightbox elementor-popup-modal page-header-dialog"
         id="elementor-popup-modal-1285"
         aria-modal="true"
         role="document"
         tabindex="0"
         :style="{ display: state.mobileMenu.show ? 'flex' : 'none' }"
         @click="state.mobileMenu.show = false">
      <div class="dialog-widget-content dialog-lightbox-widget-content animated"
           @click.stop>
        <a role="button"
           tabindex="0"
           aria-label="Close"
           href="#"
           class="dialog-close-button dialog-lightbox-close-button">
          <svg class="e-font-icon-svg e-eicon-close eicon-close">
            <use xlink:href="#eicon-close">
            </use>
          </svg>
        </a>
        <div class="dialog-header dialog-lightbox-header">
        </div>
        <div class="dialog-message dialog-lightbox-message">
          <nav data-elementor-type="popup"
               data-elementor-id="1285"
               class="elementor elementor-1285 elementor-location-popup"
               data-elementor-settings="{&quot;entrance_animation&quot;:&quot;slideInLeft&quot;,&quot;exit_animation&quot;:&quot;slideInLeft&quot;,&quot;entrance_animation_duration&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:0.2,&quot;sizes&quot;:[]},&quot;a11y_navigation&quot;:&quot;yes&quot;,&quot;timing&quot;:[]}"
               data-elementor-post-type="elementor_library"
               style="display: block;">
            <div class="elementor-element elementor-element-9dfecf4 e-con-full e-flex e-con e-parent"
                 data-id="9dfecf4"
                 data-element_type="container"
                 data-e-type="container">
              <div v-if="homeInfo?.homeContent?.pcImage1"
                   class="elementor-element elementor-element-4b511a0 elementor-widget elementor-widget-image"
                   data-id="4b511a0"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="image.default">
                <span>
                  <img width="800"
                       height="598"
                       :src="homeInfo?.homeContent?.pcImage1"
                       class="elementor-animation-shrink attachment-large size-large wp-image-21172"
                       alt=""
                       sizes="(max-width: 800px) 100vw, 800px">
                </span>
              </div>
              <div class="elementor-element elementor-element-92d08b4 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                   data-id="92d08b4"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="icon-list.default">
                <ul class="elementor-icon-list-items">
                  <li v-for="item in navList"
                      :key="'mobile-nav-' + item.label"
                      class="elementor-icon-list-item">
                    <a v-if="item.href.startsWith('http')"
                       :href="item.href"
                       target="_blank">
                      <span class="elementor-icon-list-text">
                        {{ item.label }}
                      </span>
                    </a>
                    <router-link v-else
                                 :to="item.href">
                      <span class="elementor-icon-list-text">
                        {{ item.label }}
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>

              <!-- 加入discord按钮 -->
              <!-- <div
                class="elementor-element elementor-element-4511131 elementor-align-center elementor-tablet-align-center elementor-widget-tablet__width-inherit elementor-widget elementor-widget-button"
                data-id="4511131"
                data-element_type="widget"
                data-e-type="widget"
                data-widget_type="button.default"
              >
                <a
                  class="elementor-button elementor-button-link elementor-size-sm"
                  href="https://discord.gg/clonesoles-1096540420734988419"
                  target="_blank"
                >
                  <span
                    class="elementor-button-content-wrapper"
                  >
                    <span
                      class="elementor-button-text"
                    >
                      Join the discord
                    </span>
                  </span>
                </a>
              </div> -->

              <!-- 代购平台选择 -->
              <SelectPurchasingPlatform v-show="(!state.isMobile && homeInfo.showPlatform == 'Y') || (state.isMobile && homeInfo.mobileShowPlatform == 'Y')"
                                        :expert="expert"
                                        @handleChangeExpert="handleChangeExpert" />

              <div class="mobile-search">
                <el-input v-model="state.searchValue"
                          class="search-input--image"
                          clearable
                          prefix-icon="el-icon-search"
                          placeholder="Search"
                          autocomplete="off"
                          @keyup.enter.native="goGoodsSearch">
                  <template #append>
                    <!-- 图片搜索按钮 -->
                    <ImageSearchBtn />
                  </template>
                </el-input>
              </div>

              <div class="elementor-element elementor-element-56dfdc0 elementor-shape-circle elementor-widget-tablet__width-auto elementor-grid-0 e-grid-align-center elementor-widget elementor-widget-social-icons"
                   data-id="56dfdc0"
                   data-element_type="widget"
                   data-e-type="widget"
                   data-widget_type="social-icons.default">
                <div class="elementor-social-icons-wrapper elementor-grid"
                     role="list">
                  <span v-for="(item, idx) in socialList"
                        :key="item.linkAddress || idx"
                        class="elementor-grid-item"
                        role="listitem">
                    <a class="elementor-icon elementor-social-icon"
                       :href="item.linkAddress"
                       target="_blank">
                      <span class="social-icon-html"
                            v-html="item.url" />
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </nav>
        </div>
        <div class="dialog-buttons-wrapper dialog-lightbox-buttons-wrapper">
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import SelectPurchasingPlatform from '@/components/selectPurchasingPlatform.vue'
import ImageSearchBtn from '@/components/ImageSearchBtn.vue'
export default {

  name: 'PageHeader',

  components: {
    SelectPurchasingPlatform,
    ImageSearchBtn,
  },

  props: {
    homeInfo: {
      type: Object,
      default: () => ({}),
    },
    expert: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    // 头部静态内容统一集中管理，便于后续替换多语言或配置化。
    return {
      dialogVisible: false,
      state: {
        isMobile: window.innerWidth < 768,
        mobileMenu: {
          show: false,
        },
        platform: {},
        searchValue: '',
      },
    }
  },

  computed: {
    socialList() {
      return this.homeInfo.homeContent.links.filter(item => item.enabled === 'Y')
    },

    navList() {
      const arr = [
        { href: '/home', label: 'HOME' },
        { href: '/goods', label: 'PRODUCTS' }
      ]

      if (this.homeInfo?.excelUrl) {
        arr.push({ href: this.homeInfo?.excelUrl, label: 'SPREADSHEET' })
      }

      return arr
    },
  },

  methods: {
    handleChangeExpert(platform) {
      this.state.platform = platform
      this.$emit('handleChangeExpert', platform)
    },
    // 回车搜索：带 keyword 跳转商品页，复用商品页现有查询参数。
    goGoodsSearch() {
      const raw = this.state.searchValue
      const keyword = (typeof raw === 'string' ? raw : String(raw ?? '')).trim()
      if (keyword.length <= 0) {
        return
      }
      this.dialogVisible = false
      this.state.mobileMenu.show = false
      this.$router.push({
        path: '/goods',
        query: { keyword },
      })
    },
    // 弹窗打开时强制校正层级，避免被其它遮罩覆盖。
    handleSearchOpen() {
      const syncLayer = () => {
        const dialogEl = document.querySelector('.search-dialog')
        const wrapperEl = dialogEl?.closest('.el-dialog__wrapper')
        const maskEl = document.querySelector('.v-modal.search-mask')
        if (wrapperEl) {
          wrapperEl.style.zIndex = '3210'
        }
        if (maskEl) {
          maskEl.style.zIndex = '3200'
        }
      }

      this.$nextTick(syncLayer)
      // 二次校正：兜住过渡动画/异步插入导致的层级抖动。
      setTimeout(syncLayer, 0)
    },
  }
}
</script>

<style scoped lang="scss">
header.elementor-location-header {
  position: relative;
  z-index: 3000 !important;
}

:deep(.el-input__inner) {
  color: var(--select-color);
  border: 1px solid hsl(from var(--select-border-color) h s l / 0.8) !important;
  background-color: hsl(from var(--select-border-color) h s l / 0.5);
}

/* 内联 SVG 与 img 在导航里对齐尺寸 */
.social-icon-html :deep(svg) {
  display: block;
  height: 32px;
  width: 32px;
}

.elementor-popup-modal .social-icon-html :deep(svg) {
  height: 24px;
  width: 24px;
}

.page-header-dialog {
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  z-index: 3100 !important;
}

.header-search {
  display: flex;
  align-items: center;
  margin-left: 12px;
}

.mobile-search {
  margin: 12px 0;
}

.icon-btn {
  border: 0;
  background: none !important;
  padding: 0;
  cursor: pointer;
  outline: none !important;
  line-height: 1;
  font-size: 18px;
}

.el-icon-search {
  color: var(--select-color);
}

.el-icon-search:hover {
  color: var(--primary-color);
}

:deep(.el-dialog) {
  border-radius: 8px;

  .el-dialog__header {
    padding: 0;
  }
}

@media (max-width: 768px) {
  :deep(.el-dialog) {
    width: 95% !important;
  }
}
</style>

<style lang="scss">
/* 非 scoped：el-dialog 挂载到 body 后仍能命中 */
.v-modal.search-mask {
  z-index: 3200 !important;
}

.el-dialog__wrapper .search-dialog {
  z-index: 3210 !important;
}
</style>